export const validSeleccion = ['comercial', 'residencial']

export const servicesByFocus = [
  // {
  //   sectorId: 6,
  //   translationKey: 'residential',
  //   comercialFocus: false,
  //   residencialFocus: true,
  // },
  {
    sectorId: 1,
    subsidiaryId: null,
    translationKey: 'offices',
    comercialFocus: true,
    residencialFocus: false,
  },
  {
    sectorId: 3,
    subsidiaryId: null,
    translationKey: 'retail',
    comercialFocus: true,
    residencialFocus: false,
  },
  {
    sectorId: 2,
    subsidiaryId: null,
    translationKey: 'industry',
    comercialFocus: true,
    residencialFocus: false,
  },
  // {
  //   sectorId: 13,
  //   subsidiaryId: null,
  //   translationKey: 'hotels',
  //   comercialFocus: true,
  //   residencialFocus: false,
  // },
  {
    sectorId: 9,
    subsidiaryId: null,
    translationKey: 'lands',
    comercialFocus: true,
    residencialFocus: false,
  },
  {
    sectorId: 4,
    subsidiaryId: null,
    translationKey: 'appraisals',
    comercialFocus: true,
    residencialFocus: true,
  },
  {
    sectorId: 8,
    subsidiaryId: null,
    translationKey: 'developments',
    comercialFocus: false,
    residencialFocus: true,
  },
  {
    sectorId: 6,
    subsidiaryId: 3,
    translationKey: 'san_Isidro',
    comercialFocus: false,
    residencialFocus: true,
  },
  {
    sectorId: 6,
    subsidiaryId: 1,
    translationKey: 'palermo_recoleta',
    comercialFocus: false,
    residencialFocus: true,
  },
  {
    sectorId: 6,
    subsidiaryId: 2,
    translationKey: 'nordelta',
    comercialFocus: false,
    residencialFocus: true,
  },
  {
    sectorId: 6,
    subsidiaryId: 4,
    translationKey: 'puertos',
    comercialFocus: false,
    residencialFocus: true,
  },
  {
    sectorId: 6,
    subsidiaryId: 6,
    translationKey: 'pilar',
    comercialFocus: false,
    residencialFocus: true,
  },
  {
    sectorId: 6,
    subsidiaryId: 7,
    translationKey: 'escobar',
    comercialFocus: false,
    residencialFocus: true,
  },
]

export const servicesByFocusNoBranches = [
  {
    sectorId: 6,
    translationKey: 'residential',
    comercialFocus: false,
    residencialFocus: true,
  },
  {
    sectorId: 8,
    translationKey: 'developments',
    comercialFocus: false,
    residencialFocus: true,
  },
  {
    sectorId: 1,
    subsidiaryId: null,
    translationKey: 'offices',
    comercialFocus: true,
    residencialFocus: false,
  },
  {
    sectorId: 3,
    subsidiaryId: null,
    translationKey: 'retail',
    comercialFocus: true,
    residencialFocus: false,
  },
  {
    sectorId: 2,
    subsidiaryId: null,
    translationKey: 'industry',
    comercialFocus: true,
    residencialFocus: false,
  },
  // {
  //   sectorId: 13,
  //   subsidiaryId: null,
  //   translationKey: 'hotels',
  //   comercialFocus: true,
  //   residencialFocus: false,
  // },
  {
    sectorId: 9,
    subsidiaryId: null,
    translationKey: 'lands',
    comercialFocus: true,
    residencialFocus: false,
  },
  {
    sectorId: 4,
    subsidiaryId: null,
    translationKey: 'appraisals',
    comercialFocus: true,
    residencialFocus: true,
  },
  // {
  //   sectorId: 6,
  //   subsidiaryId: 3,
  //   translationKey: 'san_Isidro',
  //   comercialFocus: false,
  //   residencialFocus: true,
  // },
  // {
  //   sectorId: 6,
  //   subsidiaryId: 1,
  //   translationKey: 'palermo_recoleta',
  //   comercialFocus: false,
  //   residencialFocus: true,
  // },
  // {
  //   sectorId: 6,
  //   subsidiaryId: 2,
  //   translationKey: 'nordelta',
  //   comercialFocus: false,
  //   residencialFocus: true,
  // },
  // {
  //   sectorId: 6,
  //   subsidiaryId: 4,
  //   translationKey: 'puertos',
  //   comercialFocus: false,
  //   residencialFocus: true,
  // },
  // {
  //   sectorId: 6,
  //   subsidiaryId: 6,
  //   translationKey: 'pilar',
  //   comercialFocus: false,
  //   residencialFocus: true,
  // },
  // {
  //   sectorId: 6,
  //   subsidiaryId: 7,
  //   translationKey: 'escobar',
  //   comercialFocus: false,
  //   residencialFocus: true,
  // },
]



// WEBPACK FOOTER //
// ./src/features/commons/constants.js